import { lazy } from 'react';
import type { RouteObject } from "react-router";

const PharmaPage = lazy(() => import('../pages/pharma/page'));
const IndustriesPage = lazy(() => import('../pages/pharma/industries/page'));
const ServicesPage = lazy(() => import('../pages/pharma/services/page'));
const PlatformsPage = lazy(() => import('../pages/pharma/platforms/page'));
const AboutPage = lazy(() => import('../pages/pharma/about/page'));
const BlogsPage = lazy(() => import('../pages/pharma/blogs/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <PharmaPage />,
  },
  {
    path: '/industries',
    element: <IndustriesPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/platforms',
    element: <PlatformsPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/blogs',
    element: <BlogsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
